import {directionalLightPreset, DIRECTIONAL_LIGHT_LABELS, DIRECTIONAL_LIGHT_MODES, type DirectionalLight} from "./DirectionalLight.ts";
import LightColorControl from "./LightColorControl.tsx";
import LightValueSlider from "./LightValueSlider.tsx";

export default function DirectionalLightInspector({light, onChange, onPreview, onCommit}: {
    light: DirectionalLight;
    onChange: (light: DirectionalLight) => void;
    onPreview: (light: DirectionalLight) => void;
    onCommit: (light: DirectionalLight) => void;
}) {
    const disabled = light.mode === "DARKNESS";
    const preview = (changes: Partial<DirectionalLight>) => onPreview({...light, ...changes});
    const commit = (changes: Partial<DirectionalLight>) => onCommit({...light, ...changes});
    return <div className="space-y-3 text-sm">
        <label className="block space-y-1">Grundbeleuchtung
            <select aria-label="Grundbeleuchtung" className="h-9 w-full rounded-md border border-input bg-surface px-2"
                value={light.mode} onChange={event => onChange(directionalLightPreset(
                    event.target.value as DirectionalLight["mode"], light.directionDegrees))}>
                {DIRECTIONAL_LIGHT_MODES.map(mode => <option key={mode} value={mode}>{DIRECTIONAL_LIGHT_LABELS[mode]}</option>)}
            </select>
        </label>
        <LightValueSlider label="Licht aus Richtung" value={light.directionDegrees} min={0} max={359} step={1}
            disabled={disabled} format={value => `${Math.round(value)}°`}
            onPreview={directionDegrees => preview({directionDegrees})}
            onCommit={directionDegrees => commit({directionDegrees})}/>
        <p className="text-xs text-muted-foreground">0° Norden · 90° Osten · 180° Süden · 270° Westen</p>
        <LightValueSlider label="Helligkeit" value={light.intensity} min={0} max={1} step={0.01}
            disabled={disabled} format={value => value.toFixed(2)}
            onPreview={intensity => preview({intensity})} onCommit={intensity => commit({intensity})}/>
        <LightValueSlider label="Farbstärke" value={light.colorStrength} min={0} max={1} step={0.01}
            disabled={disabled} format={value => value.toFixed(2)}
            onPreview={colorStrength => preview({colorStrength})} onCommit={colorStrength => commit({colorStrength})}/>
        <LightColorControl color={light.color} disabled={disabled}
            onPreview={color => preview({color})} onCommit={color => commit({color})}/>
    </div>;
}
